<div class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start">
    <div class="mt-6 mb-3">
        <h1 class="text-primary">¿Qué productos te interesan?</h1>
    </div>

        @for (item of services(); track $index) {
            <app-card-services class="w-[85%] mb-4"
            [imageUrl]="item.img"
            [data]="item"
            (cardClicked)="onCardClick($event)"
        ></app-card-services>
        }
        <div class="w-[85%] flex justify-center items-center mt-4">
            <button 
                class="btn-primary"
                [disabled]="!enabledButton()"
                (click)="onNextClick()">
                    Continuar
            </button>
        </div>
</div>